<template>
  <div class="login-page">
    <div class="login-box" v-loading="loading">
      <p class="login-title">商业化运营平台</p>
      <div class="login-form" v-if="!isResetPW">
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="70px" class="demo-ruleForm">
          <el-form-item label="账号" prop="username">
            <el-input type="text" v-model="ruleForm.username" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input type="password" v-model="ruleForm.password" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="authCode">
            <el-input type="text" v-model="ruleForm.authCode" auto-complete="off" class="code-input" @keyup.enter.native="show"></el-input>
            <img :src="imgSrc" alt="" class="code-img"/>
            <a href="javascript:;" class="change-code" @click="changeCode">换一张</a>
          </el-form-item>
          <el-form-item>
            <!-- @click="submitForm('ruleForm')"-->
            <el-button type="primary"  @click="submitForm('ruleForm')">提交</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="login-form" v-else>
          <el-form :model="resetPwdForm" :rules="resetRules" ref="resetPwdForm" class="demo-ruleForm">
            <el-form-item label="" prop="passwordOld">
              <el-input ref="passwordOld" v-model="resetPwdForm.passwordOld" type="password" placeholder="原密码"></el-input>
            </el-form-item>
            <el-form-item label="" prop="passwordNew">
              <el-input v-model="resetPwdForm.passwordNew" type="password" placeholder="新密码"></el-input>
            </el-form-item>
            <el-form-item label="" prop="passwordConfirm">
              <el-input v-model="resetPwdForm.passwordConfirm" type="password" placeholder="确认密码"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="width:100%;" @click="resetPW">提 交</el-button>
            </el-form-item>
            <div class="tips">温馨提示：您当前的密码强度太弱，为了账号安全，我们建议您修改密码。</div>
            <div class="tips">密码规则：密码必须由字母（不区分大小写）、数字组成。</div>
          </el-form>
        </div>
      <p></p>
    </div>
  </div>
</template>
<script type="es6">
  import Frame from '@/components/layout.vue'
  //基础信息组件
  const Custom = () => import('@/pages/baseInfo/customerList')
  const Adver = () =>  import('@/pages/baseInfo/adverList')
  //广告投放组件
  const HomePage = () => import('@/pages/adPut/homePage')
  const Instant = () => import('@/pages/adPut/instant')
  const Plaque = () => import('@/pages/adPut/plaque')
  const SoftWen = () => import('@/pages/adPut/softWen')
  const TailAd = () => import('@/pages/adPut/tailAd')
  const PagingAd = () => import('@/pages/adPut/pagingAd')
  //系统设置组件
  const Account = () => import('@/pages/systemSet/account')
  const Role = () => import('@/pages/systemSet/role')
  const Permiss = () => import('@/pages/systemSet/permiss')
  const Dics = () => import('@/pages/systemSet/dictionary')
  //广告审核组件
  const Ebus =() => import('@/pages/adcheck/ebus')
  const Operator =() => import('@/pages/adcheck/operator')
  export default {
    data() {
    return {
      ruleForm: {
        username: '',
        password: '',
        codeId:'',
        authCode:''
      },
      imgSrc:'img/loading-code.jpg',
      rules: {
        username: [
          { required:true,message:'请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true,message:'请输入密码', trigger: 'blur' },
          {min:6,max:20,message:'长度在6-20之间',trigger:'blur'}
        ],
        authCode:[{required:true,message:'请输入验证码',trigger:'blur'}]
      },
      loading:false,
      menus:[],
      isResetPW: false,
      // 修改密码表单及验证规则
      resetPwdForm: {
        passwordOld: '',
        passwordNew: '',
        passwordConfirm: ''
      },
      resetRules: {
        passwordOld: [{required: true, message: '请输入原密码', trigger: 'blur'}],
        passwordNew: [{required: true, validator: this.newPasswordInput, trigger: 'blur'}],
        passwordConfirm: [{required: true, validator: this.affirmInput, trigger: 'blur'}]
      },
      id: ''
    };
  },
  created(){
    this.getCode ();
  },
  methods: {
    // 重置密码表单验证函数
    affirmInput (rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.resetPwdForm.passwordNew) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    },
    newPasswordInput (rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (this.$fun.checkPassword(value)) {
        callback()
      } else {
        callback(new Error('密码由8位以上数字、字母(不区分大小写)组成'))
      }
    },
    // 重置密码提交
    resetPW () {
      this.$refs.resetPwdForm.validate((valid) => {
        if (valid) {
          let data = {
            id: this.id,
            passwordOld: this.$fun.$encode64(this.$fun.$encyptKey(this.resetPwdForm.passwordOld)),
            passwordNew: this.$fun.$encode64(this.$fun.$encyptKey(this.resetPwdForm.passwordNew)),
            passwordConfirm: this.$fun.$encode64(this.$fun.$encyptKey(this.resetPwdForm.passwordConfirm))
          }
          this.loading = true
          this.$api.post(this.$face.LoginUrl.resetPwd, data, (r) => {
            if (r.status) {
              this.reset()
              this.isResetPW = false
              this.$message.success('修改密码成功！')
              window.setTimeout(() => { this.$refs.username.focus() }, 10)
            } else {
              this.$face.overdue(r.errorCode, r.userMessage);
            }
            this.loading = false
          })
        } else {
          this.$message.error('表单填写不完整')
        }
      })
    },
    getCode (){
      var v=this;
      var now =new Date();
      var y=now.getFullYear();
      var m=now.getMonth()+1;
      var d=now.getDate();
      var h=now.getHours();
      var s=now.getMinutes();
      var miao=now.getSeconds();
      var haomiao=parseInt(now.getMilliseconds());
      var n=parseInt(Math.random()*9000+1000);
      v.ruleForm.codeId=''+y+m+d+h+s+miao+haomiao+n;
      v.$api.post(v.$face.LoginUrl.getCode, {codeId: v.ruleForm.codeId}, function(r) {
        if(r.status){
          v.imgSrc='data:image/jpg;base64,'+r.detail.imgBase64
        }
      })
    },

    changeCode(){
      this.getCode();
    },
    submitForm(formName) {
      let v=this;
      v.$refs[formName].validate((valid) => {
        if (valid) {
          v.loading=true;
          let data = {
            password: v.$fun.$encode64(v.$fun.$encyptKey(v.ruleForm.password)),
            username: v.$fun.$encode64(v.$fun.$encyptKey(v.ruleForm.username)),
            codeId: v.ruleForm.codeId,
            authCode: v.ruleForm.authCode
          }
          v.$api.post(v.$face.LoginUrl.login, data, function(r) {
            v.loading=false;
            if(r.status){
              let flag = v.$fun.checkPassword(v.ruleForm.password)
              if (flag) {
                let info=r.detail;
                sessionStorage.setItem('token', info.token);
                sessionStorage.setItem('userInfo', JSON.stringify(info));//用户信息
                sessionStorage.setItem('userMenu', JSON.stringify(info.sysMenus));//用户菜单
                v.$store.dispatch('getAllDics');
                sessionStorage.setItem('userType',info['userType']);
                v.$store.commit('setUserType');
                if(info['sysMenus'][0]!=undefined){
                  //let r=[
                  //  {path:'softWen',page:SoftWen},
                  //  {path:'homePage',page:HomePage},
                  //  {path:'instant',page:Instant},
                  //  {path:'plaque',page:Plaque},
                  //  {path:'tailAd',page:TailAd},
                  //  {path:'pagingAd',page:PagingAd},
                  //  {path:'account',page:Account},
                  //  {path:'role',page:Role},
                  //  {path:'permiss',page:Permiss},
                  //  {path:'dics',page:Dics},
                  //  {path:'ebus',page:Ebus},
                  //  {path:'operator',page:Operator},
                  //  {path:'custom',page:Custom},
                  //  {path:'adver',page:Adver}
                  //];
                  //info['sysMenus'].forEach(function(item){
                  //  let o={//插入路由
                  //          path:'/',
                  //          component:Frame,
                  //          name:item['name'],
                  //          children:[]
                  //       };
                  //  let curParentPer=item['permission'];
                  //  item['children'].forEach(function(u){
                  //    let components=null;
                  //    r.forEach(function(s){
                  //      if(u['permission']==s['path']){
                  //        components=s['page']
                  //      }
                  //    });
                  //    o['children'].push(
                  //      {path:'/'+u['permission'],component:components,name:u['name']}
                  //    )
                  //  });
                  //  v.$router.options.routes.push(o);
                  //});
                  //sessionStorage.setItem('routes',JSON.stringify(v.$router.options.routes));
                  //v.$router.addRoutes(v.$router.options.routes);//调用ad
                  let recentlyPer=info['sysMenus'][0]['children'][0]['permission'];
                  v.$router.push('/'+info['sysMenus'][0]['children'][0]['permission']);
                }else{
                  this.$message('此账号暂无权限登录!');
                }
              } else {
                v.isResetPW = true
                v.id = r.detail.id
                window.setTimeout(() => { v.$refs.passwordOld.focus() }, 10)
              }

            }else{
              v.$face.overdue(r.errorCode, r.userMessage);
              v.getCode();
            }
          })

        }
      });
    },
    show:function($event){
      let v=this;
      if($event.keyCode == 13){
        v.submitForm('ruleForm')
      }
    },
    // 重置
    reset () {
      for (let key in this.resetPwdForm) this.resetPwdForm[key] = ''
      for (let key in this.ruleForm) this.ruleForm[key] = ''
      this.id = ''
      this.getCode()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
  }
</script>
<style scoped>
.tips{
  font-size: 14px;
  line-height: 28px;
  color: red;
}
</style>




// WEBPACK FOOTER //
// src/pages/login.vue